import type { IWorkPeriodTemplateActivity } from "@/interfaces/api/work-period-template-activity.interface.ts"
import { BaseRepository } from "@/repositories/base-repository.ts"

export class WorkPeriodTemplateActivityRepository extends BaseRepository<IWorkPeriodTemplateActivity> {
  resourcePath = "administration/work-period-template-activities"
}
